export const FILTER_NAME_VISIBLE_LENGTH = 25;

export const shortFilterName = (name) => {
  return name.length > FILTER_NAME_VISIBLE_LENGTH
    ? `${name.slice(0, FILTER_NAME_VISIBLE_LENGTH).trim()}...`
    : name;
};
